import styled, { css } from 'styled-components';

import {
  SearchBarList,
  SearchBarListItem,
} from '@components/ui/search/SearchResultListStyle';

export const AirportsContainer = styled.div<{ isTravelPlanning?: boolean }>`
  position: relative;
  display: flex;
  ${({ isTravelPlanning }) =>
    isTravelPlanning &&
    css`
      border-radius: 8px;
      overflow: hidden;
    `}

  @media ${({ theme }) => `(max-width: ${theme.breakPoint.PHONE})`} {
    flex-direction: column;
  }
`;

export const AirportWrapper = styled.div`
  flex: 1;
  height: 100%;

  &.location-animation-error {
    border: 1px solid ${({ theme }) => theme.palette.coral};
    animation: shake 0.82s cubic-bezier(0.36, 0.07, 0.19, 0.97) both;
  }

  @keyframes shake {
    10%,
    90% {
      transform: translate3d(-1px, 0, 0);
    }

    20%,
    80% {
      transform: translate3d(2px, 0, 0);
    }

    30%,
    50%,
    70% {
      transform: translate3d(-4px, 0, 0);
    }

    40%,
    60% {
      transform: translate3d(4px, 0, 0);
    }
  }
`;

export const AirportCity = styled.div`
  font-size: 12;
  color: ${({ theme }) => theme.palette.darkGray};
  opacity: 0.5;
  font-weight: bold;
`;

export const AirportList = styled(SearchBarList)``;

export const AirportListItem = styled(SearchBarListItem)`
  align-items: center;
  border: none;

  @media ${({ theme }) => `(max-width: ${theme.breakPoint.PHONE})`} {
    padding: 12px 0px;
    border-bottom: 1px solid ${({ theme }) => theme.palette.lighterGray};
  }
`;

export const ArrivalAirportIconWrapper = styled.div`
  margin-left: 5px;
`;

export const SpaceWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 1px;
  position: relative;
  background-color: rgba(41, 42, 44, 0.15);
  height: 65px;
  margin: auto;
`;

export const IconContainer = styled.div`
  width: 4;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
`;

export const IconCircle = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  width: 44px;
  height: 44px;
  top: 18px;
  border-radius: 22px;
  background-color: ${({ theme }) => theme.palette.white};
  border: solid 1px rgba(41, 42, 44, 0.15);
  cursor: pointer;
`;
export const MobileCyprusAirportSearchContainer = styled.div`
  width: 100%;
  background-color: ${({ theme }) => theme.palette.NL0};
`;
export const MobileCyprusAirportSearchWrapper = styled.div`
  width: 100%;
  padding-left: 15px;
`;

export const LocationAnimationErrorBox = styled.div<{
  hasError: boolean;
  hasAnimationOnError?: boolean;
  borderRadius?: string;
}>`
  flex: 1;
  overflow: hidden;
  border-radius: ${({ borderRadius }) => borderRadius};
  background-color: ${({ theme }) => theme.palette.NL0};
  ${({ hasError, hasAnimationOnError = true, borderRadius = '0' }) =>
    hasError &&
    css`
      border-radius: ${borderRadius};
      border: ${({ theme }) => `1px solid ${theme.palette.coral}`};
      animation: ${() =>
        hasAnimationOnError &&
        'shake 0.82s cubic-bezier(0.36, 0.07, 0.19, 0.97)'};
    `}

  @keyframes shake {
    10%,
    90% {
      transform: translate3d(-1px, 0, 0);
    }

    20%,
    80% {
      transform: translate3d(2px, 0, 0);
    }

    30%,
    50%,
    70% {
      transform: translate3d(-4px, 0, 0);
    }

    40%,
    60% {
      transform: translate3d(4px, 0, 0);
    }
  }
`;
